import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthentificationService } from '../services/authentication.service';
import { ROUTES } from '../constants/routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthentificationService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const isLoggedIn = this.authService.getAccessToken();
    if (isLoggedIn) {
      this.authService.storeQrCodeInfoFromUrl();
      return true;
    } else {
      this.router.navigate([ROUTES.LOGIN]);
      return false;
    }
  }
}
